module.exports = __webpack_public_path__ + "static/media/technology3.ac3aef44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/technology3.jpg
// module id = 203
// module chunks = 6